import RuStorePackage from './RuStorePackage';

export default RuStorePackage;
